module.exports = __webpack_public_path__ + "static/media/n14.ec034939.jpg";